import React from 'react';

const AnimatedShape = () => {
  return (
    <div className="animation-container">
      <div className="shape1"></div>
      <div className="shape2"></div>
      <div className="shape3"></div>
      <div className="shape4"></div>
      <div className="shape5"></div>
    </div>
    
    
  );
};

export default AnimatedShape;
